export default __webpack_public_path__ + "static/media/1001.57fe921f.png";